import { render, staticRenderFns } from "./startDate.vue?vue&type=template&id=6f20d4ac&"
import script from "./startDate.vue?vue&type=script&lang=js&"
export * from "./startDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports